
interface AccordionProps {
  title: string;
  answer: string;
  id: string;
  openAccordion: string | null; 
  setAccordionOpen: (id: string | null) => void; 
}

const Accordion = ({ title, answer, id, openAccordion, setAccordionOpen }: AccordionProps) => {

  const handleAccordion =()=>{
    if(id !== openAccordion){
      setAccordionOpen(id)
    }else{
      setAccordionOpen(null)
    }
  }


  return (
    <div className={` justify-center items-center py-2 md:py-6 px-1 ${id !== "4" && "border-b" }  border-gray-400`}>
      <button
        onClick={handleAccordion}
        className="flex justify-between items-center w-full "
      >
        <span className="text-lg md:text-2xl font-bold text-[#fff]">{title}</span>
        {/* {accordionOpen ? <span>-</span> : <span>+</span>} */}
        <svg
          className="fill-emerald-500 shrink-0 ml-8"
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="7"
            width="16"
            height="2"
            rx="1"
            className={`transform origin-center transition duration-200 ease-out ${
              id === openAccordion && "!rotate-180"
            }`}
          />
          <rect
            y="7"
            width="16"
            height="2"
            rx="1"
            className={`transform origin-center rotate-90 transition duration-200 ease-out ${
             id === openAccordion &&  "!rotate-180"
            }`}
          />
        </svg>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out text-slate-600 text-xl font-semibold pt-2 ${
          id === openAccordion
            ? "grid-rows-[1fr] opacity-100"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden text-neutral-300 text-sm md:text-lg">{answer}</div>
      </div>
    </div>
  );
};

export default Accordion;